require('./receiptDetail.scss')

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// @ commons
const { ReceiptPreview } = require('components/commons/receiptPreview/receiptPreview');
import { OKButton } from 'commonsComponents/OKButton';
import OKTableRowDetails from 'components/rebrand/OKTableRowDetails/OKTableRowDetails';
import OKTableRowDetailsItem from 'components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;
// @ vendors
import { connect } from 'react-redux';
// @ helpers
import receiptNumberHelper from 'utilities/receiptNumberHelper';
import { formatDate } from 'utilities/dateHelper'
// @ actions
import  { changeTab, requestAccountDebitsPdf } from 'actions/accountDebits';
import { expandRow } from 'actions/accountDebits/authorizations';
import { receiptGetPreview } from 'actions/accountDebits/receipts';
// @ constants
import { RECEIPT_STATUS_CODES_PENDING } from 'constants/index';
const { VIEWER } = require('constants/contactCenter/pdfViewer');
class receiptDetail extends Component {
    componentWillMount() {
        const { immAccount, immTransaction, receiptGetPreview, immProfile } = this.props;
        if (!immTransaction.get('preview')) {
            const codprod = immTransaction.get('codprod');
            const numsor = immTransaction.get('numsor');
            const receiptId = immTransaction.get('receiptNumber');
            const newProduct = immAccount.get('newProduct');
            const numCont = immAccount.get('newContractNumber');
            const idCent = immTransaction.getIn(['idcent', 'centro']);
            const idioma = immProfile.get('originCountry');
            receiptGetPreview(immTransaction.get('accountId'), receiptId, codprod, numsor, newProduct, numCont, idCent, idioma);
        }
    }

    handleChangeTab = () => {
        const { changeTab, immTransaction, expandRow } = this.props;
        const authorizationId = immTransaction.get('authorizationId');
        const accountId = immTransaction.get('accountId');
        expandRow(accountId, authorizationId);
        changeTab(1, true);
    }

    handleGetPdf = () => {
        const { immTransaction, requestAccountDebitsPdf } = this.props
        if(__CONTACT_CENTER__) {
            requestAccountDebitsPdf(immTransaction, VIEWER)
        } else {
            requestAccountDebitsPdf(immTransaction)
        }
    }

    render() {
        const {
            immAccountDebits,
            immAccountReceiptDownload,
            immTransaction,
        } = this.props;
        const beneficiaryName = immTransaction.get('titular');
        const issuingCompanyName = immTransaction.get('nombre');
        const receiptNumber = receiptNumberHelper(immTransaction.get('receiptNumber'));
        const issuerId = immTransaction.get('identemi');
        const referenceNumber = immTransaction.get('refmand');
        const date = immTransaction.get('fecvenci');

        return (
            <tr>
                <td className="container-fluid" colSpan="7">
                    <div className="row receipt-detail__container">
                        <div className="col-sm-6">
                            <OKTableRowDetails title="accountDebitDetail-header">
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-beneficiaryName"
                                    value={beneficiaryName} />
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-receiptNumber"
                                    value={receiptNumber} />
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-issuingCompanyId"
                                    value={issuerId} />
                                <OKTableRowDetailsItem
                                    title="accountDebitDetail-referenceNumber"
                                    value={referenceNumber} />
                                <OKButton
                                    modifier="link-complementary"
                                    onClick={this.handleChangeTab}
                                >
                                    <FormattedText value="accountDebits-showAuthorization" />
                                </OKButton>
                            </OKTableRowDetails>
                        </div>
                        <div className="col-sm-6">
                            {
                                !RECEIPT_STATUS_CODES_PENDING.includes(immTransaction.get('cestado')) &&
                                    <div className="receipt-detail__preview">
                                        <ReceiptPreview
                                            error={null}
                                            immAccountReceiptDownload={immAccountReceiptDownload}
                                            loading={!immTransaction.get('previewError') && !immTransaction.get('preview')}
                                            downloading={immAccountDebits.get('isFetching')}
                                            onClickDownloadButton={this.handleGetPdf}
                                            src={immTransaction.get('preview')}
                                            title={`${issuingCompanyName} - ${formatDate(date)}`}
                                        />
                                    </div>
                            }
                        </div>
                    </div>
                </td>
            </tr>
        )
    }
}

receiptDetail.propTypes = {
    changeTab: PropTypes.func,
    expandRow: PropTypes.func,
    immAccount: PropTypes.object.isRequired,
    immAccountDebits: PropTypes.object.isRequired,
    immAccountReceiptDownload: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    receiptGetPreview: PropTypes.func.isRequired,
    requestAccountDebitsPdf: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired
};

export default connect(
    (state, ownProps) => {
        const accountId = ownProps.immTransaction.get('accountId');
        return {
            immAccount: state.accounts.get('byId').get(accountId),
            immAccountDebits: state.accountDebits,
            immAccountReceiptDownload: state.accountReceiptDownload,
            immProfile: state.profile,
        }
    },
    {
        changeTab,
        expandRow,
        receiptGetPreview,
        requestAccountDebitsPdf
    }
)(receiptDetail);
